<template>
  <Modal
    class="cc-modal"
    width="800"
    footer-hide
    v-model="visibility"
    title="DNS设置"
  >
    <div class="content" v-if="data">
      <div class="link-warp">
        <div
          :class="['link-item', { active: current === item.value }]"
          v-for="item in navList"
          :key="item.value"
          @click="onClick(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
      <template v-if="current === 0 && DNSResult">
        <div class="row rowline">
          <div class="name">域名:</div>
          <div class="label">{{ data.dn }}</div>
        </div>
        <div class="row rowline">
          <div class="name">DNS类型:</div>
          <div class="label">
            <RadioGroup v-model="form.dnsPlatformNum">
              <Radio :label="2">解析DNS</Radio>
              <Radio :label="1">第三方DNS</Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="row rowline">
          <div
            class="name"
            :style="{ paddingTop: form.dnsPlatformNum === 1 ? '10px' : '0' }"
          >
            DNS记录值:
          </div>
          <div class="label" style="flex: 1">
            <template v-if="form.dnsPlatformNum === 0">
              <div class="row">
                <div
                  class="name"
                  v-for="(item, index) in dnsList0"
                  :key="'p' + index"
                >
                  <span style="color: #333333">DNS{{ index + 1 }}：</span>
                  {{ item }}
                </div>
              </div>
            </template>
            <template v-if="form.dnsPlatformNum === 2">
              <div class="row">
                <div
                  class="name"
                  v-for="(item, index) in dnsList1"
                  :key="'p' + index"
                >
                  <span style="color: #333333">DNS{{ index + 1 }}：</span>
                  {{ item }}
                </div>
              </div>
            </template>
            <template v-if="form.dnsPlatformNum === 1">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-start;
                  padding-top: 10px;
                "
              >
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                  "
                >
                  <div
                    v-for="(item, index) in dnsInputList"
                    :key="'i' + index"
                    class="flx-row-s-c"
                    style="
                      margin-bottom: 10px;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: flex-start;
                    "
                  >
                    <div class="f-14 c-g">DNS{{ index + 1 }}：</div>
                    <Input
                      v-model.trim="dnsInputList[index]"
                      placeholder="请填写"
                      style="width: 200px; margin-right: 10px"
                    />
                  </div>
                </div>
                <div style="flex: 0 0 105px; display: flex">
                  <div
                    v-show="dnsInputList.length > 1"
                    class="btn-add"
                    @click="cutEvent"
                  >
                    -
                  </div>
                  <div
                    v-show="dnsInputList.length < 6"
                    class="btn-add"
                    @click="addEvent"
                  >
                    +
                  </div>
                </div>
              </div>
            </template>
            <div class="row">
              <Checkbox v-model="single"> 点此阅读</Checkbox>
              <span style="cursor: pointer; color: #2d8cf0" @click="dnsModel"
                >《域名管理系统DNS服务协议》</span
              >
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="current === 0 && !DNSResult">
        <div class="nodata">DNS信息加载失败！</div>
      </template>
      <template v-if="current === 1">
        <div class="data-content">
          <Table
            class="domain-table"
            :columns="columns"
            :data="list"
            :loading="tableLoading"
          >
          </Table>
        </div>
      </template>
    </div>
    <div class="foot">
      <div class="page-tool" v-if="current === 1">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          show-total
          @on-change="onPageChange"
        />
      </div>
      <Button
        style="margin-right: 20px"
        v-if="current === 0"
        :loading="loading"
        @click="onConfirm"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
    <!-- 域名管理系统DNS服务协议 -->
    <rule-modal
      :show.sync="dnsModelShow"
      :content="dnsRulesContent"
      :title="dnsRulesTitle"
    ></rule-modal>
  </Modal>
</template>
<script>
import { domainDnsList, domainDnsCreate, domainDnsLogList } from "api/customer.js";
import ruleModal from "components/ruleModal.vue";
import dnsRules from "assets/rule/dnsRules";
export default {
  name: "DNSListModal",
  components: {
    ruleModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      current: 0,
      navList: [
        {
          value: 0,
          label: "DNS设置",
        },
        {
          value: 1,
          label: "DNS修改记录",
        },
      ],
      list: [],
      tableLoading: false,
      columns: [
        {
          key: "createdTime",
          title: "修改时间",
          align: "center",
        },
        {
          key: "dns",
          title: "原DNS",
          align: "center",
        },
      ],
      loading: false,
      form: {
        dnsPlatformNum: null,
        dn: "",
        id: "",
        dnsPlatform: 0,
      },
      dnsList0: [],
      dnsList1: [],
      dnsInputList: ["", ""],
      DNSResult: false,
      single: false,
      page: 1,
      limit: 10,
      total: 0,
      // 域名管理系统域名push服务协议
      dnsModelShow: false,
      dnsRulesContent: "",
      dnsRulesTitle: "",
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.dn) {
          this.req_domainDnsList();
        }
      },
    },
  },
  methods: {
    // 域名管理系统DNS服务协议
    dnsModel() {
      this.dnsModelShow = true;
      if (!this.dnsRulesContent) {
        this.dnsRulesContent = dnsRules.content;
        this.dnsRulesTitle = dnsRules.title;
      }
    },
    // 获取DNS记录
    async req_domainDnsList() {
      const { code, data } = await domainDnsList({ domainId: this.data.id });
      if (code === 200 && data) {
        this.form.dn = data.ym;
        this.form.dnsPlatformNum = data.type;
        this.form.id = data.id;
        this.dnsList0 = data.defaults.filter(
          (item) => item.dnsPlatform === 0
        )[0].values;
        this.dnsList1 = data.defaults.filter(
          (item) => item.dnsPlatform === 2
        )[0].values;
        if (data.type === 0) {
          this.dnsList0 = data.valueSet;
        } else if (data.type === 2) {
          this.dnsList1 = data.valueSet;
        } else if (data.type === 1) {
          for (const i in data.valueSet) {
            if (i < 2) {
              this.dnsInputList[i] = data.valueSet[i];
            } else {
              this.dnsInputList.push(data.valueSet[i]);
            }
          }
        }
        this.DNSResult = true;
      }
    },
    cutEvent() {
      this.dnsInputList.splice(this.dnsInputList.length - 1, 1);
    },
    addEvent() {
      this.dnsInputList.push("");
    },
    onCancel() {
      this.current = 0;
      this.page = 1;
      this.list = [];
      this.visibility = false;
    },
    // 确定
    onConfirm() {
      if (this.form.dnsPlatformNum === null) {
        this.$Message.warning("请选择DNS类型！");
        return;
      }
      if (!this.single) {
        this.$Message.warning(`请同意并阅读《域名管理系统DNS服务协议》！`);
        return;
      }
      const params = {
        ids: [this.form.id],
        type: this.form.dnsPlatformNum,
      };
      if (this.form.dnsPlatformNum === 1) {
        const DNSList = this.dnsInputList.filter(
          (item) => item != null && item !== ""
        );
        if (DNSList.length <= 0) {
          this.$Message.warning("请至少输入一个DNS！");
          return;
        }
        params.values = DNSList;
      }
      this.$Modal.confirm({
        title: "确认修改",
        content: "<p>确定要修改DNS设置吗？</p>",
        onOk: async () => {
          this.formLoading = true;
          try {
            const res = await domainDnsCreate(params);
            if (res.code === 200 && res.data.length === 0) {
              this.$Message.success("修改成功！");
              this.single = false;
              this.onClick(1);
            } else {
              this.$Message.warning("域名设置DNS失败!");
            }
            this.formLoading = false;
          } catch (error) {
            this.$Message.warning("域名设置DNS失败!");
          }
        },
      });
    },
    // 切换数据列表
    onClick(val) {
      this.current = val;
      if (val === 1) {
        this.onPageChange(1);
      }
    },
    // 日志数据
    async req_domainDnsLogList() {
      try {
        let params = {
          id: this.form.id,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data, result } = await domainDnsLogList(params);
        this.tableLoading = false;
        if (code === 200 && result) {
          this.list = data.list;
          this.total = 0;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 分页
    onPageChange(val) {
      this.page = val;
      this.req_domainDnsLogList();
    },
  },
};
</script>
<style lang="less" scoped>
.link-warp {
  padding: 0 15px;
  margin-top: 20px;
  .link-item {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 30px;
    font-size: 16px;
    font-weight: 600;
    color: #4f5867;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    // &::before {
    //   content: "";
    //   position: absolute;
    //   bottom: -1px;
    //   width: 0;
    //   height: 2px;
    //   background-color: transparent;
    //   transition: all 0.3s;
    // }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    border: 1px solid #759de6;
    // &::before {
    //   width: 100%;
    //   background-color: #3992e9;
    // }
  }
}
.cc-modal {
  .content {
    min-height: 100px;
    max-height: 500px;
    overflow: hidden;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.data-content {
  min-height: 100px;
  max-height: 500px;
  overflow: auto;
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.row.rowline {
  border-bottom: 1px dashed #dcdee2;
}
.nodata {
  height: 200px;
  line-height: 200px;
  text-align: center;
}
.btn-add {
  width: 32px;
  height: 32px;
  line-height: 26px;
  font-size: 20px;
  font-weight: 700;
  border: 1px solid #dcdee2;
  border-radius: 50%;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
  transition: all 0.3s;
}
.page-tool {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
